// Helper funkcije za upravljanje demo podacima u localStorage
// Omogućava da se mock podaci dopunjavaju tokom sesije

const STORAGE_KEYS = {
  SERVICES: 'demoServices',
  CATEGORIES: 'demoCategories',
  APPOINTMENTS: 'demoAppointments',
  EXCEPTIONS: 'demoExceptions',
  EMPLOYEES: 'demoEmployees',
  CUSTOMERS: 'demoCustomers',
  TENANT: 'demoTenant'
};

// Inicijalizuj demo storage sa mock podacima - uvek resetuj na početne vrednosti
export const initializeDemoStorage = (mockData) => {
  // Uvek resetuj na početne mock podatke kada se aplikacija učita u demo modu
  localStorage.setItem(STORAGE_KEYS.SERVICES, JSON.stringify(mockData.mockServices || []));
  localStorage.setItem(STORAGE_KEYS.CATEGORIES, JSON.stringify(mockData.mockCategories || []));
  localStorage.setItem(STORAGE_KEYS.APPOINTMENTS, JSON.stringify(mockData.mockAppointments || []));
  localStorage.setItem(STORAGE_KEYS.EXCEPTIONS, JSON.stringify([]));
  localStorage.setItem(STORAGE_KEYS.EMPLOYEES, JSON.stringify(mockData.mockEmployees || []));
  localStorage.setItem(STORAGE_KEYS.CUSTOMERS, JSON.stringify(mockData.mockCustomers || []));
  localStorage.setItem(STORAGE_KEYS.TENANT, JSON.stringify(mockData.mockTenant || {}));
};

// Dohvati sve usluge (inicijalne + dodate)
export const getDemoServices = () => {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEYS.SERVICES) || '[]');
  } catch {
    return [];
  }
};

// Dohvati sve kategorije (inicijalne + dodate)
export const getDemoCategories = () => {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEYS.CATEGORIES) || '[]');
  } catch {
    return [];
  }
};

// Dohvati sve termine (inicijalne + dodati)
export const getDemoAppointments = () => {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEYS.APPOINTMENTS) || '[]');
  } catch {
    return [];
  }
};

// Dohvati sve izuzetke (inicijalne + dodati)
export const getDemoExceptions = () => {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEYS.EXCEPTIONS) || '[]');
  } catch {
    return [];
  }
};

// Dohvati sve zaposlene (inicijalne + dodati)
export const getDemoEmployees = () => {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEYS.EMPLOYEES) || '[]');
  } catch {
    return [];
  }
};

// Dohvati sve korisnike (inicijalne + dodati)
export const getDemoCustomers = () => {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEYS.CUSTOMERS) || '[]');
  } catch {
    return [];
  }
};

// Dohvati tenant podatke
export const getDemoTenant = () => {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEYS.TENANT) || '{}');
  } catch {
    return {};
  }
};

// Dodaj novu uslugu
export const addDemoService = (service) => {
  const services = getDemoServices();
  const newService = {
    ...service,
    _id: service._id || `demo-service-${Date.now()}`,
    createdAt: new Date().toISOString()
  };
  services.push(newService);
  localStorage.setItem(STORAGE_KEYS.SERVICES, JSON.stringify(services));
  return newService;
};

// Ažuriraj uslugu
export const updateDemoService = (serviceId, updates) => {
  const services = getDemoServices();
  const index = services.findIndex(s => s._id === serviceId);
  if (index !== -1) {
    services[index] = {
      ...services[index],
      ...updates,
      _id: serviceId,
      updatedAt: new Date().toISOString()
    };
    localStorage.setItem(STORAGE_KEYS.SERVICES, JSON.stringify(services));
    return services[index];
  }
  return null;
};

// Obriši uslugu
export const deleteDemoService = (serviceId) => {
  const services = getDemoServices();
  const filtered = services.filter(s => s._id !== serviceId);
  localStorage.setItem(STORAGE_KEYS.SERVICES, JSON.stringify(filtered));
  return true;
};

// Dodaj novu kategoriju
export const addDemoCategory = (category) => {
  const categories = getDemoCategories();
  const newCategory = {
    ...category,
    _id: category._id || `demo-category-${Date.now()}`,
    createdAt: new Date().toISOString()
  };
  categories.push(newCategory);
  localStorage.setItem(STORAGE_KEYS.CATEGORIES, JSON.stringify(categories));
  return newCategory;
};

// Ažuriraj kategoriju
export const updateDemoCategory = (categoryId, updates) => {
  const categories = getDemoCategories();
  const index = categories.findIndex(c => c._id === categoryId);
  if (index !== -1) {
    categories[index] = {
      ...categories[index],
      ...updates,
      _id: categoryId,
      updatedAt: new Date().toISOString()
    };
    localStorage.setItem(STORAGE_KEYS.CATEGORIES, JSON.stringify(categories));
    return categories[index];
  }
  return null;
};

// Obriši kategoriju
export const deleteDemoCategory = (categoryId) => {
  const categories = getDemoCategories();
  const filtered = categories.filter(c => c._id !== categoryId);
  localStorage.setItem(STORAGE_KEYS.CATEGORIES, JSON.stringify(filtered));
  return true;
};

// Dodaj novi termin
export const addDemoAppointment = (appointment) => {
  const appointments = getDemoAppointments();
  const newAppointment = {
    ...appointment,
    _id: appointment._id || `demo-appointment-${Date.now()}`,
    createdAt: new Date().toISOString()
  };
  appointments.push(newAppointment);
  localStorage.setItem(STORAGE_KEYS.APPOINTMENTS, JSON.stringify(appointments));
  return newAppointment;
};

// Ažuriraj termin
export const updateDemoAppointment = (appointmentId, updates) => {
  const appointments = getDemoAppointments();
  const index = appointments.findIndex(a => a._id === appointmentId);
  if (index !== -1) {
    appointments[index] = {
      ...appointments[index],
      ...updates,
      _id: appointmentId,
      updatedAt: new Date().toISOString()
    };
    localStorage.setItem(STORAGE_KEYS.APPOINTMENTS, JSON.stringify(appointments));
    return appointments[index];
  }
  return null;
};

// Obriši termin
export const deleteDemoAppointment = (appointmentId) => {
  const appointments = getDemoAppointments();
  const filtered = appointments.filter(a => a._id !== appointmentId);
  localStorage.setItem(STORAGE_KEYS.APPOINTMENTS, JSON.stringify(filtered));
  return true;
};

// Dodaj novi izuzetak
export const addDemoException = (exception) => {
  const exceptions = getDemoExceptions();
  const newException = {
    ...exception,
    _id: exception._id || `demo-exception-${Date.now()}`,
    createdAt: new Date().toISOString()
  };
  exceptions.push(newException);
  localStorage.setItem(STORAGE_KEYS.EXCEPTIONS, JSON.stringify(exceptions));
  return newException;
};

// Ažuriraj izuzetak
export const updateDemoException = (exceptionId, updates) => {
  const exceptions = getDemoExceptions();
  const index = exceptions.findIndex(e => e._id === exceptionId);
  if (index !== -1) {
    exceptions[index] = {
      ...exceptions[index],
      ...updates,
      _id: exceptionId,
      updatedAt: new Date().toISOString()
    };
    localStorage.setItem(STORAGE_KEYS.EXCEPTIONS, JSON.stringify(exceptions));
    return exceptions[index];
  }
  return null;
};

// Obriši izuzetak
export const deleteDemoException = (exceptionId) => {
  const exceptions = getDemoExceptions();
  const filtered = exceptions.filter(e => e._id !== exceptionId);
  localStorage.setItem(STORAGE_KEYS.EXCEPTIONS, JSON.stringify(filtered));
  return true;
};

// Ažuriraj tenant podatke
export const updateDemoTenant = (updates) => {
  const tenant = getDemoTenant();
  const updated = {
    ...tenant,
    ...updates,
    updatedAt: new Date().toISOString()
  };
  localStorage.setItem(STORAGE_KEYS.TENANT, JSON.stringify(updated));
  return updated;
};

// Dodaj novog zaposlenog
export const addDemoEmployee = (employee) => {
  const employees = getDemoEmployees();
  const newEmployee = {
    ...employee,
    _id: employee._id || `demo-employee-${Date.now()}`,
    createdAt: new Date().toISOString()
  };
  employees.push(newEmployee);
  localStorage.setItem(STORAGE_KEYS.EMPLOYEES, JSON.stringify(employees));
  return newEmployee;
};

// Ažuriraj zaposlenog
export const updateDemoEmployee = (employeeId, updates) => {
  const employees = getDemoEmployees();
  const index = employees.findIndex(e => e._id === employeeId);
  if (index !== -1) {
    employees[index] = {
      ...employees[index],
      ...updates,
      _id: employeeId,
      updatedAt: new Date().toISOString()
    };
    localStorage.setItem(STORAGE_KEYS.EMPLOYEES, JSON.stringify(employees));
    return employees[index];
  }
  return null;
};

// Obriši zaposlenog
export const deleteDemoEmployee = (employeeId) => {
  const employees = getDemoEmployees();
  const filtered = employees.filter(e => e._id !== employeeId);
  localStorage.setItem(STORAGE_KEYS.EMPLOYEES, JSON.stringify(filtered));
  return true;
};

// Dodaj novog korisnika (customer)
export const addDemoCustomer = (customer) => {
  const customers = getDemoCustomers();
  const newCustomer = {
    ...customer,
    _id: customer._id || `demo-customer-${Date.now()}`,
    createdAt: new Date().toISOString()
  };
  customers.push(newCustomer);
  localStorage.setItem(STORAGE_KEYS.CUSTOMERS, JSON.stringify(customers));
  return newCustomer;
};

// Ažuriraj korisnika (customer)
export const updateDemoCustomer = (customerId, updates) => {
  const customers = getDemoCustomers();
  const index = customers.findIndex(c => c._id === customerId);
  if (index !== -1) {
    customers[index] = {
      ...customers[index],
      ...updates,
      _id: customerId,
      updatedAt: new Date().toISOString()
    };
    localStorage.setItem(STORAGE_KEYS.CUSTOMERS, JSON.stringify(customers));
    return customers[index];
  }
  return null;
};

// Obriši korisnika (customer)
export const deleteDemoCustomer = (customerId) => {
  const customers = getDemoCustomers();
  const filtered = customers.filter(c => c._id !== customerId);
  localStorage.setItem(STORAGE_KEYS.CUSTOMERS, JSON.stringify(filtered));
  return true;
};

// Resetuj demo storage (vrati na inicijalne mock podatke)
export const resetDemoStorage = (mockData) => {
  localStorage.removeItem(STORAGE_KEYS.SERVICES);
  localStorage.removeItem(STORAGE_KEYS.CATEGORIES);
  localStorage.removeItem(STORAGE_KEYS.APPOINTMENTS);
  localStorage.removeItem(STORAGE_KEYS.EXCEPTIONS);
  localStorage.removeItem(STORAGE_KEYS.EMPLOYEES);
  localStorage.removeItem(STORAGE_KEYS.TENANT);
  initializeDemoStorage(mockData);
};
